import { useQuery } from "@tanstack/react-query";
import { getPublicacoesSimilares } from "../../../api";

const useGetPublicacoesSimilares = (id: number, produtoId: number = 1, quantidade: number = 5) => {
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ["get_publicacoes_similares", id, produtoId, quantidade],
        queryFn: () => getPublicacoesSimilares(id, produtoId, quantidade),
        refetchOnWindowFocus: false
    });

    return {
        data,
        isLoading,
        isError,
        error,
    };
};

export default useGetPublicacoesSimilares;